<template>
  <div class="addBrowseNew">
    <div class="section">
      <div class="stategyHeader">
        <div @click="toStrategy()">
          <i class="iconfont icon-fanhui1"></i>
          <span class="toStyle">{{$t('strategy.to')}}</span>
        </div>
        <span>{{$t('browse.addBrowse')}}</span>
      </div>
      <div class="stategyBody">
        <!-- 步骤内容 -->
        <div class="gridbox" slot="content" style="width:80%;">
          <el-form :model="addBrowseData" :rules="formRules" ref="creatform" size="small">
            <!-- 账号信息 -->
            <div class="form-group grid">
              <div class="form-groupname">
                <span>{{ $t('browse.accountInfo') }}</span>
              </div>
              <!-- 用户名 -->
              <el-form-item :label="`${$t('browse.username')}：`" prop="browseUsr">
                <el-input v-model.trim="addBrowseData.browseUsr" 
                @clear="Bytecheck" @keyup.native="UserByte" @keyup.enter.native="$refs.creatPwd.focus()" clearable></el-input>
                <div class="inputlo">
                  <div :class="isError ? 'input_spans' : 'sucess'" v-show="!Byte">
                    <span>{{ usrtip }}</span>
                  </div>
                  <div class="input_span" v-show="Byte">
                    <span style="font-size: 12px;font-weight: bold;">{{ $t('signup.Byte_1') }}</span>
                    <span style="margin-left:2px;font-size:12px;font-weight:bold;color:#f00;">{{ Bytes }}</span>
                    <span style="font-size: 12px;font-weight: bold;margin-left: 2px;">{{ $t('signup.Byte_2') }}</span>
                  </div>
                </div>
              </el-form-item>
              <!-- 密码 -->
              <el-form-item :label="`${$t('browse.password')}：`" prop="browsePwd">
                <el-input v-model.trim="addBrowseData.browsePwd" clearable ref="creatPwd"
                @clear="pwdcheck" @input.native="Passwordlevel"
                @keyup.enter.native="$refs.creatconfPwd.focus()"></el-input>
                <div class="inputlo">
                  <div :class="passpwdError ? 'pwd_span' : 'sucess'" v-show="!strength">
                    <span>{{ pwdtip }}</span>
                  </div>
                  <div class="input_span" v-show="strength">
                    <span style="font-size: 12px;font-weight: bold;">{{ $t('signup.qiangdu') }}</span>
                    <span class="juxing" ref="Passwordlevel"></span>
                    <span style="font-size: 12px;font-weight: bold;margin-left: 5px;">{{ count }}</span>
                  </div>
                </div>
              </el-form-item>
              <!-- 确认密码 -->
              <el-form-item :label="`${$t('browse.confirmPassword')}：`" prop="browseConfirmPwd">
                <el-input v-model.trim="addBrowseData.browseConfirmPwd" clearable  ref="creatconfPwd"
                @keyup.enter.native="$refs.createmail.focus()"></el-input>
                <div class="inputlo">
                  <div :class="confpwdError ? 'confpwd_span' : 'sucess'">
                    <span>{{ confpwdtip }}</span>
                  </div>
                </div>
              </el-form-item>
            </div>
            <!-- 用户信息 -->
            <div class="form-group grid">
              <div class="form-groupname">
                <span>{{ $t('browse.usrInfo') }}</span>
              </div>
              <!-- 邮箱 -->
              <el-form-item :label="`${$t('browse.email')}：`" prop="browseEmail">
                <el-input v-model.trim="addBrowseData.browseEmail" clearable ref="createmail"
                @clear="emailcheck" @keyup.enter.native="$refs.creatmobile.focus()"></el-input>
                <div class="inputlo">
                  <div :class="emailError?'email_span':'sucess'">
                    <span>{{emailtip}}</span>
                  </div>
                </div>
              </el-form-item>
              <!-- 手机 -->
              <el-form-item :label="`${$t('browse.mobile')}：`" prop="browseMobile">
                <el-input v-model.trim="addBrowseData.browseMobile" clearable ref="creatmobile"
                @clear="phonecheck" @keyup.enter.native="$refs.creatdesc.focus()"></el-input>
                <div class="inputlo">
                  <div :class="phoneError?'phone_span':'sucess'">
                    <span>{{phonetip}}</span>
                  </div>
                </div>
              </el-form-item>
              <!-- 备注 -->
              <el-form-item :label="`${$t('browse.desc')}：`" prop="browseDesc">
                <el-input
                  type="textarea"
                  :placeholder="$t('firmware.enter_content')"
                  v-model="addBrowseData.browseDesc"
                  :maxlength="100"
                  show-word-limit
                  ref="creatdesc"
                >
                </el-input>
              </el-form-item>
            </div>
            <!-- 选择项目 -->
            <div class="form-group grid">
              <div class="form-groupname">
                <span>{{ $t('browse.device') }}</span>
              </div>
              <!-- 选择项目 -->
              <el-form-item :label="`${$t('browse.pleaseDevice')}：`" prop="browseProject" class="el-form-group-item">
                <el-checkbox-group v-model="addBrowseData.browseProject" class="eb-checkbox-group">
                  <el-checkbox v-for="item in projectList" :key="item.pid" name="browseProject"  :label="item.pid">{{item.pname}}</el-checkbox>
                </el-checkbox-group>
                <div class="inputlo">
                  <div :class="ProjectError?'project_span':'sucess'">
                    <span>{{Projecttip}}</span>
                  </div>
                </div>
              </el-form-item>
            </div>
            <!-- 账号启禁用 -->
            <div class="form-group grid">
              <div class="form-groupname">
                <span>{{ $t('browse.enableStatus') }}</span>
              </div>
              <!-- 选择状态 -->
              <el-form-item :label="`${$t('browse.pleaseStatus')}：`" prop="browseStatus" class="el-form-group-item">
                <el-radio-group v-model="addBrowseData.browseStatus" v-removeAriaHidden class="eb-radio-group">
                  <el-radio :label="true">{{$t('browse.Enable')}}</el-radio>
                  <el-radio :label="false">{{$t('browse.Disable')}}</el-radio>
                </el-radio-group>
              </el-form-item>  
            </div>
          </el-form>
        </div>
        <!-- 步骤按钮 -->
        <div style="display: flex;justify-content: center;margin: 25px 0;">
          <div>
            <el-button class="btn btn-light" @click="goBack()">
              <span style="width: 100px;">{{$t('strategy.go_back')}}</span>
            </el-button>
            <el-button style="margin-left: 10px;"  class="btn btn-dark" @click="goConfirm('creatform')">
              <span style="width: 100px;">{{$t('strategy.confirm')}}</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { i18n } from "@/i18n";
import encryption from "@/assets/js/encryption";
export default {
  data(){
    // 定义数据规则
    var validateusr = (rule, value, callback) => {
      var ref = /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/;
      if (!value) {
        callback(new Error(""));
        this.usrtip = this.$t("message.uname_is_required");
        this.isError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.usrtip = this.$t("signup.usrformat");
        this.isError = true;
      } else {
        callback();
      }
    };
    var validatepwd = (rule, value, callback) => {
      var ref = /^[\w]{6,32}$/;
      if (!value) {
        callback(new Error(""));
        this.pwdtip = this.$t("message.pwd_is_required");
        this.passpwdError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.pwdtip = this.$t("signup.pwdformat");
        this.passpwdError = true;
      } else {
        callback();
      }
    };
    //新建账号的密码确认
    var validateconfPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdAgain");
        this.confpwdError = true;
      } else if (value !== this.addBrowseData.browsePwd) {
        callback(new Error(""));
        this.confpwdtip = this.$t("message.pwdNotsame");
        this.confpwdError = true;
      } else {
        this.confpwdtip = "";
        callback();
      }
    };
    var validateemail = (rule, value, callback) => {
      var ref = /^(?=\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$).{0,64}$/;
      if (!value) {
        callback(new Error(""));
        this.emailtip = this.$t("message.email_is_required");
        this.emailError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.emailtip = this.$t("message.email_info");
        this.emailError = true;
      } else {
        this.emailtip = "";
        callback();
      }
    };
    var validatephone = (rule, value, callback) => {
      var ref = /^\d{6,32}$/;
      if (!value) {
        callback(new Error(""));
        this.phonetip = this.$t("message.mobile_is_required");
        this.phoneError = true;
      } else if (!ref.test(value)) {
        callback(new Error(""));
        this.phonetip = this.$t("signup.mobileformat");
        this.phoneError = true;
      } else {
        this.phonetip = " ";
        callback();
      }
    };
    var validateProject = (rule, value, callback) => {
      if (value.length<1) {
        callback(new Error(""));
        this.Projecttip = this.$t("browse.pleaseDevice_title");
        this.ProjectError = true;
      }else {
        this.Projecttip = " ";
        callback();
      }
    };
    return{
      formRules: {
        browseUsr: [{ required: true, validator: validateusr, message: this.usrtip,trigger: "change" }],
        browsePwd: [{ required: true, validator: validatepwd, trigger: "change" }],
        browseConfirmPwd: [{ required: true, validator: validateconfPwd, trigger: "change" }],
        browseEmail: [{ required: true, validator: validateemail, trigger: "change" }],
        browseMobile: [{ required: true, validator: validatephone, trigger: "change" }],
        browseProject: [
          {
            type: 'array',
            required: true,
            validator: validateProject, 
            trigger: ['blur','change']
          },
        ],
      },
      // 新增子账户
      addBrowseData:{
        browseUsr:"",
        browsePwd:"",
        browseConfirmPwd:"",
        browseEmail:"",
        browseMobile:"",
        browseDesc:"",
        browseProject:[],
        browseStatus:true,
      },
      pidList:[],
      confpwdError: false,
      isError: false,
      emailError: false,
      passpwdError: false,
      phoneError: false,
      Bytes: "",
      count: "",
      Byte: false,
      usrtip: "",
      pwdtip: "",
      emailtip: "",
      phonetip: "",
      confpwdtip: "",
      Projecttip: "",
      ProjectError:false,
      strength: false,
      projectList:[],
    }
  },
  created(){
    this.getProjectList()
  },
  watch:{
    "addBrowseData.browsePwd"(){
      if (this.addBrowseData.browseConfirmPwd&&this.addBrowseData.browsePwd!=this.addBrowseData.browseConfirmPwd) {
        this.confpwdtip = this.$t("message.pwdNotsame");
        this.confpwdError = true;
      }else{
        this.confpwdtip = '';
        this.confpwdError = false;
      }
    }
  },
  methods:{
    Bytecheck () {
      this.Byte = false;
      this.usrtip = this.$t("message.uname_is_required");
    },
    pwdcheck () {
      this.strength = false;
      this.pwdtip = this.$t("message.pwd_is_required");
    },
    emailcheck() {

    },
    phonecheck() {
      
    },
    UserByte () {
      var usernameRegex = /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/;
      if (usernameRegex.test(this.addBrowseData.browseUsr)) {
        //用户格式正确的情况下
        this.Byte = true;
        this.Bytes = this.addBrowseData.browseUsr.length;
      } else {
        this.Byte = false;
        // this.usrtip = this.$t('signup.usrformat')
      }
    },
    Passwordlevel () {
      var reg = /^[\w]{6,32}$/i; //判断密码格式是否正确
      var reg1 = /[a-zA-Z]/; //字母
      var reg2 = /\d/; //数字
      var reg3 = /_/; //下划线
      if (reg.test(this.addBrowseData.browsePwd)) {
        //密码格式正确的情况下
        if (
          reg1.test(this.addBrowseData.browsePwd) &&
          reg2.test(this.addBrowseData.browsePwd) &&
          reg3.test(this.addBrowseData.browsePwd)
        ) {
          //高级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#3CBD35";
          this.count = this.$t("signup.qiang");
        } else if (
          (reg1.test(this.addBrowseData.browsePwd) && reg2.test(this.addBrowseData.browsePwd)) ||
          (reg1.test(this.addBrowseData.browsePwd) && reg3.test(this.addBrowseData.browsePwd)) ||
          (reg2.test(this.addBrowseData.browsePwd) && reg3.test(this.addBrowseData.browsePwd))
        ) {
          //中级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FA9D1F";
          this.count = this.$t("signup.zhong");
        } else if (
          reg1.test(this.addBrowseData.browsePwd) ||
          reg2.test(this.addBrowseData.browsePwd) ||
          reg3.test(this.addBrowseData.browsePwd)
        ) {
          //低级密码
          this.strength = true;
          this.$refs.Passwordlevel.style.backgroundColor = "#FF0000";
          this.count = this.$t("signup.di");
        }
      } else {
        this.strength = false;
      }
    },
    // 确定添加子用户
    goConfirm(creatform){
      this.$refs[creatform].validate(valid=>{
        if (!valid) return false;
        this.addBrowseData.browseProject.forEach(item=>{
          this.pidList.push(item)
        })
        let params={
          usr:this.addBrowseData.browseUsr,
          pwd:encryption.byte2hex(
                encryption.rc4(
                  encryption.sha1(this.addBrowseData.browsePwd),
                  this.$store.state.user.secret
                )
              ),
          pid:JSON.stringify(this.pidList).slice(1,-1),
          mobile:this.addBrowseData.browseMobile,
          email:this.addBrowseData.browseEmail,
          enable:this.addBrowseData.browseStatus,
          desc:this.addBrowseData.browseDesc,
        }
        this.$request.get("addPlantBrowserEs",params).then((res)=>{
          this.pidList=[]
          if (res.err==0) {
            // this.$router.push({
            //   path: "browseAccount",
            // });
            this.$message.success(this.$t("browse.addSuccess"));
            this.$emit('noticeBrowseAccountBox', 1);
          }else{
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        })
      })
      
    },
    //获取项目列表数据
    getProjectList(){
      let params={
        i18n: this.$lang.currentLang,
        devtype: 2304,
        page: 0,
        pagesize: 99,
      }
      this.$request.get("queryPlantsInfoEs",params).then((res)=>{
        if (res.err==0) {
          this.projectList=res.dat.info
        }else{
          this.projectList=[]
        }
      })
    },
    // 返回子账户列表
    toStrategy(){
      // this.$router.push({
      //   path: "browseAccount",
      // });
      this.$emit('noticeBrowseAccountBox', 1);
    },
    goBack(){
      // this.$router.push({
      //   path: "browseAccount",
      // });
      this.$emit('noticeBrowseAccountBox', 1);
    },
  }
}
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");
.addBrowseNew{
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;
  // 统一按钮
  
  .btn {
    height: 32px;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }
  /deep/.el-textarea__inner,.el-input__inner{
    background: #2b3842;
    color: #fff;
    border: 1px solid #A3A9B5;
  }
  /deep/.el-textarea__inner,.el-input__inner:focus{
    border: 1px solid #A3A9B5 !important;
  }
  // 时间"-"号调整
  /deep/.el-range-separator{
    line-height: normal !important;
    color: #fff !important;
  }
  // 时间图标
  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: -6px;
    right: 10px;
    height: 24px;
    width: 24px;
    background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }
  /deep/.el-range-editor .el-range-input{
    background-color: #2b3842;
    color: #fff;
  }
  /deep/.el-form-item__label {
    color: rgba(255, 255, 255, 1);
  }
  /deep/.el-form-item {
    color: rgba(255, 255, 255, 1);
  }
  
  /deep/.el-input .el-input__inner {
    background-color: #2b3842;
    border: 1px solid #A3A9B5;
    color:#fff;
  }
  /deep/.el-select {
    width: 100%;
  }
  /deep/.el-radio__input.is-checked + .el-radio__label {color: @primaryTextColor !important;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {background: @primaryTextColor !important;border-color: #28d4c1 !important;
  }
  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {color: @primaryTextColor !important;
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {background: @primaryTextColor !important;border-color: #28d4c1 !important;
  }
  /deep/.el-checkbox .el-checkbox__label{
    width: 100%;
    font-size: 14px;
    color: #fff;
  }
  .section{
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: auto;
    .stategyHeader{
      display: flex;
      padding: 0 0 15px 0;
      font-size: 20px;
      color: #ffffff;
      align-items: center;
      background-color: #2D3F4B;
      i{
        font-size: 26px;
      }
      div:hover{
          cursor: pointer;
      }
      .toStyle{
        margin: 0 20px 0 5px;
      }
    }
    .stategyBody{
      display: flex;
      flex-direction:column;
      justify-content:flex-start;
      align-items: center;
      .gridbox{
        .juxing {
          display: inline-block;
          width: 100px;
          height: 10px;
          border: 0px solid #fff;
          margin-left: 5px;
        }
        .input_spans,
        .pwd_span,
        .email_span,
        .phone_span,
        .confpwd_span,
        .project_span {
          height: 20px;
          line-height: 20px;
          color: #f56c6c;
          font-size: 12px;
        }

        .input_span {
          height: 20px;
          line-height: 20px;
        }

        .sucess {
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          color: #999;
          // font-family: "Microsoft YaHei";
        }

        /deep/ .el-form-item__error {
          display: none;
        }
        /deep/.el-form-item__label{
          width: 100px;
          height: 100%;
        }
        /deep/.el-radio{
          padding: 5px 0;
        }
        /deep/.el-radio__label{
          color: #fff;
        }
        .form-group {
          padding: 49px 46px 31px;
          margin-top: 50px;
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-radius: 16px;
          position: relative;
          color: #fff;
          .showresultbox {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            // 图标
            .showsuccess {
              
              border: 3px solid rgba(37, 255, 174, 1);
              background-color: rgba(19, 195, 156, 1);
              background-image: url(../../assets/img/general/Icon_Finished.png);
              background-size: 70px 70px;
            }
            .showfail {
              border: 3px solid rgba(246, 189, 189, 1);
              background: rgba(251, 75, 75, 1);
              background-image: url(../../assets/img/general/Icon_Failed.png);
              background-size: 120px 120px;
            }
            .showbase {
              width: 100px;
              height: 100px;
              box-sizing: border-box;
              background-repeat: no-repeat;
              background-position: center;
              border-radius: 50%;
            }
            // 提示
            .showresulttext {
              font-weight: bold;
              font-size: 18px;
              margin-top: 20px;
              margin-bottom: 30px;
              color: rgba(255, 255, 255, 1);
            }
            // 操作
            .showoperate {
              text-align: center;
            }
            .showresultbtn {
              width: 102px;
              height: 30px;
              margin-top: 10px;
              border-radius: 6px;
              background: @primaryTextColor;
              color: rgba(34, 45, 53, 1);
              font-size: 14px;
            }
          }
          
          .search {
            margin: 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgb(34, 45, 53);

            .search-label {
              display: inline-block;
              color: #ffffff;
              font-weight: bold;
              line-height: 48px;
              font-size: 14px;
              padding-left: 16px;
            }

            /deep/.el-select {
              width: 100px;
              border-right: 1px solid #738089;
            }

            /deep/.el-select:hover {
              background: @primaryColorTransparency30;
            }

            /deep/.el-input {
              width: 100%;
              text-align: center;
            }

            /deep/.el-input__inner {
              background: transparent;
              border: none;
              height: 48px;
              line-height: 48px;
              color: #ffffff;
              padding: 0 16px;
            }

            /deep/.el-input__suffix {
              right: 0px;
            }

            .button {
              height: 48px;
              line-height: 48px;
              padding: 0 25px;
              margin-top: 0px;
              color: @primaryTextColor;
              background: transparent;
              border: none;
            }

            .search-alert {
              position: absolute;
              top: 0;
              // left: 0;
              right: 0;
              width: 100%;
              height: 48px;
              z-index: 1;
              background: rgb(34, 45, 53);
              display: flex;
              align-items: center;
              justify-content: space-between;

              .searchDiv {
                position: absolute;
                top: 0;
                // left: 0;
                right: 0;
                width: 400px;
                height: 48px;
                z-index: 2;
                background: rgb(34, 45, 53);
                display: flex;
                align-items: center;
                justify-content: space-between;
              }

              .searchAll {

                // display: flex;
                // align-items: center;
                // justify-content: flex-end;
                /deep/.el-input__inner {
                  width: 220px;
                  padding-left: 10px !important;
                }
              }

              .search-device {
                display: inline-block;
                line-height: 48px;
                padding: 0 15px;
                font-size: 14px;
                background: #202D35;
                color: #33FFB6;
                cursor: pointer;

                &:hover {
                  background: @primaryColorTransparency30;
                  color: rgb(255, 255, 255, 1);
                }
              }

              .search-hide {
                display: inline-block;
                // position: absolute;
                // right: -58px;
                line-height: 48px;
                padding: 0 15px;
                font-size: 14px;
                background: #202D35;
                color: #7B8395;
                border-left: 1px solid #7B8395;
                cursor: pointer;

                &:hover {
                  background: @primaryColorTransparency30;
                  color: rgb(255, 255, 255, 1);
                }
              }

              /deep/.el-input {
                flex: 1;
              }

              /deep/.el-input .el-input__clear {
                width: 48px;
                color: #7B8395;
              }

              /deep/.el-input .el-input__clear:hover {
                background: @primaryColorTransparency30;
                color: rgb(255, 255, 255, 1);
              }

              /deep/.el-input .el-input__inner,
              /deep/.el-input .el-input__inner:hover {
                height: 48px;
                border-radius: 0px;
                border: none;
                background: #202D35;
                color: #ffffff;
                padding-left: 40px;
              }

              /deep/.el-input__prefix {
                left: 0px;
              }

              /deep/.el-input__icon {
                width: 40px;
              }

              /deep/.el-input__suffix {
                right: 0px;
              }

              /deep/.el-input__suffix:hover {
                background: @primaryColorTransparency30;
                color: rgb(255, 255, 255, 1);
              }

              /deep/.el-icon-circle-close:before {
                content: 'X'
              }

              /deep/.el-input:not(:last-child) {
                margin-right: 0px;
              }
            }

            /deep/.el-input:not(:last-child) {
              margin-right: 0px;
            }

            /deep/.el-select:not(:last-child) {
              margin-right: 0px;
            }

            // .searchLeft {}
            .searchRight {
              display: flex;
              justify-content: flex-end;
              position: relative;

              .buttonDeviceJurisdiction {
                padding: 0 17px 0 12px;
                background-color: @primaryTextColor;
                color: #222D35;
                border-radius: 0;

                span {
                  padding-left: 5px;
                }
              }
            }
          }

          .table {
            flex: 1;
            overflow: auto;

            /deep/.el-icon-loading {
              font-size: 28px;
            }
          }
          .tablemain {
            border: none;
            background-color: rgb(34, 45, 53);
            width: 100%;

            .operation i {
              color: @primaryTextColor;
            }

            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
              width: 16px;
              height: 16px;
              background: transparent;
              border: 1px solid rgb(180, 184, 193);
              border-radius: 0px;
            }

            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
              top: 2px;
              left: 5px;
            }

            /deep/.el-table__header th {
              height: 48px;
            }

            /deep/.el-table__header th.is-leaf {
              border-color: rgba(198, 209, 221, 0.5);
              // border-bottom: none;
            }

            /deep/.el-table__header th>.cell {
              font-weight: normal;
              font-size: 12px;
            }

            /deep/.el-table__body tr,
            /deep/.el-table__body td {
              background-color: rgb(34, 45, 53);
              color: #ffffff;
              border-color: rgba(198, 209, 221, 0.5);
            }

            /deep/.el-table__body td.el-table-column--selection {
              background-color: rgb(65, 80, 90);
              color: #ffffff;
            }

            /deep/.el-table__body .cell.el-tooltip {
              font-size: 14px;
            }

            /deep/.el-table__fixed-right::before,
            /deep/.el-table__fixed::before {
              display: none;
            }

            /deep/.el-table--border::after,
            /deep/.el-table--group::after {
              width: 0px;
            }

            ::-webkit-scrollbar {
              width: 6px;
              height: 6px;
              background-color: #222d35;
              z-index: 9999;
            }

            // 关于复选框
            /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
              background: @primaryTextColor;
              border: 1px solid @primaryTextColor;
            }

            /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
              background: @primaryTextColor;
              border: 1px solid @primaryTextColor;
            }

            // 关于头部右侧空白
            /deep/.el-table__fixed-right-patch {
              background-color: rgb(65, 80, 90);
              border-bottom: none;
            }

            /deep/th.gutter {
              background-color: rgb(65, 80, 90);
            }

            // 关于表格右侧边线(无效)
            /deep/.el-table--border::after {
              display: none;
            }

            /deep/.el-table--group::after {
              display: none;
            }
          }

          .tablebottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid rgba(198, 209, 221, 0.5);

            // 分页
            .pagination {
              line-height: 48px;
              height: 48px;
              padding: 0;
              margin: 0;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-right: 16px;

              /deep/.el-pager li {
                vertical-align: middle;
              }

              /deep/.el-select .el-input {
                width: 90px;
                margin: 0px;
              }

              /deep/.el-input .el-input__inner {
                background-color: #202D35;
                color: #ffffff;
              }

              /deep/.el-input__suffix {
                right: 10px;
              }

              /deep/.el-pagination__sizes {
                margin: 0px;
                height: 48px;
                line-height: 48px;
              }

              /deep/.el-pagination__total {
                color: #fff;
                padding-left: 15px;
                border-left: 1px solid #7B8395;
                height: 48px;
                line-height: 48px;
              }

              /deep/.el-pager li:not(.disabled).active {
                // background: #15C491;
                // color: #ffffff;
                background-color: #2B3842;
                color: #15C491;
              }

              // li:not(.disabled):not(.active):hover
              /deep/.el-pager li:not(.disabled):hover {
                background-color: @primaryColorTransparency30;
                color: rgba(255, 255, 255, 1);
              }

              /deep/.el-pager li {
                background-color: #2B3842;
                color: #7B8395;
              }

              // 页条数下拉
              /deep/.el-select .el-input .el-input__inner {
                border: none;
                height: 48px;
                line-height: 48px;
                border-radius: 0px;
              }

              /deep/.el-select .el-input .el-input__inner:hover {
                background: @primaryColorTransparency30;
              }

              // 跳页
              /deep/.el-pagination__jump {
                color: #ffffff;
              }

              /deep/.el-pagination__editor {
                padding: 0px 6px;
              }

              /deep/.el-pagination__editor.el-input .el-input__inner {
                border: 1px solid #7B8395;
              }
            }

            // 分页前后按钮
            /deep/.el-pagination.is-background .btn-next,
            /deep/.el-pagination.is-background .btn-prev {
              background-color: #2B3842;
              color: #7B8395;
            }

            /deep/.el-pagination.is-background .btn-next:hover,
            /deep/.el-pagination.is-background .btn-prev:hover {
              background-color: @primaryColorTransparency30;
              color: rgba(255, 255, 255, 1);
            }

            /deep/.el-pagination.is-background button[disabled],
            /deep/.el-pagination.is-background button[disabled]:hover {
              background-color: #2B3842;
              color: #7B8395;
            }
          }
          /deep/.dialog-content .el-form-item--small .el-form-item__label {
            line-height: 40px;
          }

          /deep/.latlon .el-form-item__content {
            display: block;
          }
          /deep/.linkage .el-form-item__content {
            display: block;
          }

          /deep/.dialog-content .el-form-item--small.linkage .el-form-item__label {
            display: block;
            width: 100%;
            text-align: left;
            line-height: 40px;
          }

          /deep/.el-icon-arrow-up:before {
            color: @primaryTextColor;
          }
          // 时间图标
          /deep/.el-icon-date:before {
            left: 10px;
            content: "";
            display: inline-block;
            margin-top: 8px;
            height: 24px;
            width: 24px;
            background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
            background-size: 100%;
            background-position: center;
          }

          // /deep/.el-input .el-input__inner {
          //   height: 40px;
          //   line-height: 40px;
          // }

          /deep/.el-input-group__append,
          /deep/.el-input-group__prepend {
            background: #2b3842;

            .el-dropdown {
              color: #ffffff;
            }

            .el-icon-arrow-down:before {
              color: @primaryTextColor;
            }
          }
          }

        .form-groupname {
          position: absolute;
          top: -20px;
          left: 50px;
          .sc(26px, #ffffff);
          font-weight: 600;
          background: #222D35;
          padding: 0 8px;
        }
      }
      
      ::v-deep{

        .el-step__title.is-process,.el-step__title.is-wait{
          color: #fff ;
        }
        .el-step__head.is-process,.el-step__heads.is-wait{
          .el-step__icon.is-text{//这里设置的是下一步和等待状态里的文字颜色
            color: #fff !important;
            border-color: @primaryTextColor !important;
            background-color: @primaryTextColor !important;
          }
          .el-step__main{
                .ai-step__title,.el-step__description {
                  // color: @primaryTextColor !important;
                }
                .el-step__title.is-process{
                  color: @primaryTextColor !important;
                }
            }
        }
        .el-step__head.is-finish{
          color: @primaryTextColor !important;
          .el-step__icon.is-text{//这里设置的是已完成状态里的文字颜色
            color: @primaryTextColor !important;
            border-color: @primaryTextColor !important;
          }
        }
        .el-step__title.is-finish{
          color: @primaryTextColor !important;
        }
        .el-step__line-inner{//这里设置的是完成后过渡线条颜色
          border-color: @primaryTextColor !important;
        }
        .el-step__head.is-success,.el-step__title.is-success{//这里设置的是完成后的颜色
          background-color: @primaryTextColor !important;
        }
      }
    }
  }
}
</style>
<style lang="less">
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 0px;
  }

  // 滚动条
  ::-webkit-scrollbar {
    // width: 0px;
    // height: 0px;
    background-color: transparent;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(164, 182, 200, 0.2);
  }
}

// 控制项日期选择样式
.select-date .el-input .el-input__inner,
.select-date .el-picker-panel__footer {
  background: #222d35
}

.select-date .el-button {
  background: #222d35;
  color: @primaryTextColor;

  &:hover {
    background: #222d35;
    color: @primaryTextColor;
  }
}

.selectClearNew {

  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

.deviceName .el-tooltip {
  color: @primaryTextColor;
}
</style>